import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private sessionService: SessionService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    
    if (request.headers.has('Skip-Interceptor')) {
      const headers = request.headers.delete('Skip-Interceptor');
      const clonedRequest = request.clone({ headers });
      return next.handle(clonedRequest);
    }

    const token = this.sessionService.getToken();
    if (token !== null) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token.accessToken}`,
        },
      });
    }

    return next.handle(request);
  }
}